import React from 'react';
import PropTypes from 'prop-types';
import * as S from './H.styles';

const H = ({ align, children, font, type, variant, weight, modifier }) => (
  <S.H
    align={align}
    as={`h${type}`}
    font={font}
    type={type}
    variant={variant}
    weight={weight}
    modifier={modifier}
  >
    {children}
  </S.H>
);

H.defaultProps = {
  type: '1',
  variant: 'neutral',
  font: 'primary',
  weight: 'regular',
  align: 'left',
  modifier: 'regular',
};

H.propTypes = {
  type: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']).isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'secondary-1',
    'secondary-2',
    'secondary-3',
    'neutral',
    'neutral-1',
    'danger',
    'warning',
    'info',
    'success',
  ]).isRequired,
  weight: PropTypes.oneOf(['regular', 'bold']).isRequired,
  align: PropTypes.oneOf(['center', 'right', 'left']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted'])
    .isRequired,
};

export default H;
